/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import './Header.css'

import { Link, useLocation } from 'react-router-dom'

import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from 'react-redux';
import { getPartners } from '../../actions/partners.action';
import i18next from 'i18next';
import { getServices } from '../../actions/services.action';
import { getNews } from '../../actions/news.action';
import { getPassengers } from '../../actions/passengers.action';

const Header_footer = () => {

    const { t } = useTranslation()
    const dispatch = useDispatch()
    const {language} = i18next
    const [visible_tab, setVisibleTab] = useState('home')
    const [dropDownShow, setDropDownShow] = React.useState("hidden")
    const location = useLocation()
    
    useEffect(() => {
        dispatch(getPartners(language))
        dispatch(getServices(language))
        dispatch(getNews(language))
        dispatch(getPassengers(language))
    }, [language])

    const passengersResults = useSelector(state => state.passengers).passengers.results
    const partnersResults = useSelector(state => state.partners).partners.results
    const servicesResults = useSelector(state => state.services).services.results
    const newsResults = useSelector(state => state?.news).news.results


    useEffect(() => {

        if (location.pathname === '/') {
            setVisibleTab('home')
        }
        if (location.pathname === '/about') {
            setVisibleTab('air_about')
        }
        if (location.pathname === '/online_table') {
            setVisibleTab('online_table')
        }
        if (location.pathname === '/passengers') {
            setVisibleTab('passengers')
        }
        if (location.pathname === '/business') {
            setVisibleTab('business')
        }
        if (location.pathname === '/services') {
            setVisibleTab('services')
        }
        if (location.pathname === '/news') {
            setVisibleTab('news')
        }
        if (location.pathname === '/gallery') {
            setVisibleTab('gallery')
        }
        if (location.pathname === '/contact') {
            setVisibleTab('contact')
        }

    }, [location])

    function removeHtmlTags(input) {
        const htmlTagsRegex = /<[^>]*>/g;
        const cleanText = input.replace(htmlTagsRegex, '');
        return cleanText;
    }


    return (
        <>
            <div className="Header_footer">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className='header_footer_left'>
                                <ul>
                                    <li className={visible_tab === 'home' ? 'active_' : null}>
                                        <Link to={'/'}>{t('home_page')}</Link>
                                        <div className={visible_tab === 'home' ? 'bottom_' : null}></div>
                                    </li>
                                    <li className={visible_tab === 'air_about' ? 'active_' : null}>
                                        <Link to={'/about'}>{t('about_us')}</Link>
                                        <div className={visible_tab === 'air_about' ? 'bottom_' : null}></div>
                                    </li>
                                    <li className={visible_tab === 'online_table' ? 'active_' : null}>
                                        <Link to={'/online_table'}>{t('online_table')}</Link>
                                        <div className={visible_tab === 'online_table' ? 'bottom_' : null}></div>
                                    </li>
                                    <li onMouseEnter={() => setDropDownShow("passengers")} onMouseLeave={() => setDropDownShow("hidden")} className={`relative ${visible_tab === 'passengers' ? 'active_' : null}`}>
                                        <Link to={'/passengers'}>{t('passengers')}</Link>
                                        <div className={visible_tab === 'passengers' ? 'bottom_' : null}></div>
                                        <div className={visible_tab === 'services' ? 'bottom_' : null}></div>
                                        {dropDownShow === "passengers" && <div onMouseEnter={() => setDropDownShow("passengers")} className="absolute z-[100] -left-10 w-[200px] bg-white h-[150px] px-2 py-2 overflow-y-auto flex flex-col gap-y-2">
                                            {passengersResults?.map((item, index) => (
                                               <div key={index}>
                                               {item.route_type === "id" ? 
                                                <Link style={{flexShrink: "none", lineHeight: "none", height: "auto", display: "block", fontSize: "12px"}} to={`/passengers/${item.id}`} className='text-xs cursor-pointer hover:text-green-700'>{removeHtmlTags(item.title )}</Link>
                                               : 
                                               <Link style={{flexShrink: "none", lineHeight: "none", height: "auto", display: "block", fontSize: "12px"}} to={`/passengers/${item.slug}`} className='text-xs cursor-pointer hover:text-green-700'>{removeHtmlTags(item.title )}</Link>}
                                               </div>
                                            ))}
                                        </div>
                                        }
                                    </li>
                                    <li onMouseEnter={() => setDropDownShow("business")} onMouseLeave={() => setDropDownShow("hidden")} className={`relative ${visible_tab === 'business' ? 'active_' : null}`}>
                                        <Link to={'/business'}>{t('business')}</Link>
                                        <div className={visible_tab === 'business' ? 'bottom_' : null}></div>
                                        {dropDownShow === "business" && <div onMouseEnter={() => setDropDownShow("business")} className="absolute z-[100] -left-10 w-[200px] bg-white h-[150px] px-2 py-2 overflow-y-auto flex flex-col gap-y-2">
                                            {partnersResults?.map((item) => (
                                                <Link style={{flexShrink: "none", lineHeight: "none", height: "auto", display: "block", fontSize: "12px"}} to={`/business/${item.id}`} className='text-xs cursor-pointer hover:text-green-700'>{removeHtmlTags(item.title )}</Link>
                                            ))}
                                        </div>
                                        }
                                    </li>
                                    <li onMouseEnter={() => setDropDownShow("services")} onMouseLeave={() => setDropDownShow("hidden")} className={`relative ${visible_tab === 'services' ? 'active_' : null}`}>
                                        <Link to={'/services'}>{t('services')}</Link>
                                        <div className={visible_tab === 'services' ? 'bottom_' : null}></div>
                                        {dropDownShow === "services" && <div onMouseEnter={() => setDropDownShow("services")} className="absolute z-[100] -left-10 w-[200px] bg-white h-[150px] px-2 py-2 overflow-y-auto flex flex-col gap-y-2">
                                            {servicesResults?.map((item) => (
                                                <Link style={{flexShrink: "none", lineHeight: "none", height: "auto", display: "block", fontSize: "12px"}} to={`/services/${item.id}`} className='text-xs cursor-pointer hover:text-green-700'>{removeHtmlTags(item.title )}</Link>
                                            ))}
                                        </div>
                                        }
                                    </li>
                                    <li onMouseEnter={() => setDropDownShow("news")} onMouseLeave={() => setDropDownShow("hidden")} className={`relatvie ${visible_tab === 'news' ? 'active_' : null}`}>
                                        <Link to={'/news'}>{t('news')}</Link>
                                        <div className={visible_tab === 'news' ? 'bottom_' : null}></div>
                                        {dropDownShow === "news" && <div onMouseEnter={() => setDropDownShow("news")} className="absolute z-[100] -left-10 w-[200px] bg-white h-[150px] px-2 py-2 overflow-y-auto flex flex-col gap-y-2">
                                            {newsResults?.map((item) => (
                                                <Link style={{flexShrink: "none", lineHeight: "none", height: "auto", display: "block", fontSize: "12px"}} to={`/news/${item.id}`} className='text-xs cursor-pointer hover:text-green-700'>{removeHtmlTags(item.title )}</Link>
                                            ))}
                                        </div>
                                        }
                                    </li>
                                    <li className={visible_tab === 'gallery' ? 'active_' : null}>
                                        <Link to={'/gallery'}>{t('gallery')}</Link>
                                        <div className={visible_tab === 'gallery' ? 'bottom_' : null}></div>
                                    </li>
                                    <li className={visible_tab === 'contact' ? 'active_' : null}>
                                        <Link to={'/contact'}>{t('contact')}</Link>
                                        <div className={visible_tab === 'contact' ? 'bottom_' : null}></div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Header_footer